import { render, staticRenderFns } from "./m-importFuncModal.vue?vue&type=template&id=3b52496a&scoped=true&"
import script from "./m-importFuncModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-importFuncModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-importFuncModal.vue?vue&type=style&index=0&id=3b52496a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b52496a",
  null
  
)

export default component.exports